import * as sharedTypes from 'src/actions/shared/sharedTypes';
import createDocumentResource from 'src/actions/shared/createDocumentResource';
import { STATUS_FAILED, STATUS_LOADING, STATUS_SUCCEEDED } from 'src/presentation/hooks/useResource';

export class TemporaryAuthToken {
  userId: string;
  orgId: string;
  token: string;
}

const temporaryAuthTokensResource = createDocumentResource<TemporaryAuthToken>({
  name: 'temporaryAuthTokens',
  endpoint: '', // Explicitly add calls to temp auth token custom gateway.
  type: TemporaryAuthToken,
  reducers: {
    facebookLoginTemporaryTokenStarted(state) {
      state.loadingState = STATUS_LOADING;
    },
    facebookLoginTemporaryTokenSuccess(state, action) {
      state.value = action.payload as TemporaryAuthToken;
      state.loadingState = STATUS_SUCCEEDED;
    },
    facebookLoginTemporaryTokenError(state) {
      state.loadingState = STATUS_FAILED;
    },
  },
});

const facebookLoginTemporaryToken: sharedTypes.AppThunk =
  () =>
  async (dispatch, _, { gateways }) => {
    try {
      dispatch(temporaryAuthTokensResource.actions.facebookLoginTemporaryTokenStarted({}));
      const result = (await gateways.temporaryAuthTokens.facebookLoginTemporaryToken()) as TemporaryAuthToken;
      dispatch(temporaryAuthTokensResource.actions.facebookLoginTemporaryTokenSuccess(result));
      return result;
    } catch (err) {
      dispatch(temporaryAuthTokensResource.actions.facebookLoginTemporaryTokenError({}));
    }
  };

temporaryAuthTokensResource.effects.facebookLoginTemporaryToken = facebookLoginTemporaryToken;

export default temporaryAuthTokensResource;
